import { render, staticRenderFns } from "./PerformanceStatistics.vue?vue&type=template&id=e1b418b0&"
import script from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
export * from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceStatistics.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports